(ns portal.role-table.view
  (:require ["@mui/material/Pagination$default" :as Pagination]
            [common.widgets.input :refer [input]]
            [common.widgets.table :as t]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn permission-circle [v]
  [:div.permission-circle
   (case v
     0 nil
     1 [:div.permission-circle__filled-half]
     2 [:div.permission-circle__filled]
     nil)])

(defn permission-cell
  [permissions]
  (into
   [:div.permission-cell
    [:div.permission-cell__column
     [:div.permission-cell__permission
      [permission-circle (:management permissions)]
      "Management"]
     [:div.permission-cell__permission
      [permission-circle (:advertisers permissions)]
      "Advertisers"]]
    [:div.permission-cell__column
     [:div.permission-cell__permission
      [permission-circle (:campaigns permissions)]
      "Campaigns"]
     [:div.permission-cell__permission
      [permission-circle (:templates permissions)]
      "Templates"]]
    [:div.permission-cell__column
     [:div.permission-cell__permission
      [permission-circle (:products permissions)]
      "Products"]
     [:div.permission-cell__permission
      [permission-circle (:adsets permissions)]
      "Adsets"]]]))

(defn role-cell [{:keys [name attached-users]}]
  [:div.role-cell
   [:p.role-cell__name name]
   [:p.role-cell__users
    (str attached-users " Users")]])

(def fields
  [{:column-key :name
    :label "Role"
    :component role-cell
    :sortable? true}
   {:column-key :permissions
    :label "Permissions"
    :component permission-cell}])

(defn- row
  [role]
  [t/table-row {:on-click #(rf/dispatch [:role-table.db/click-row role])}
   (for [{:keys [column-key component]} fields]
     [t/table-cell
      {:key column-key
       :data-testid (str "role-table-" (name column-key) "-column")
       :class ["table-role__column"
               (str "table-role__column--" (name column-key))]}
      [component (column-key role)]])])

(defn- column
  [{:keys [column-key label sortable?]}]
  (if sortable?
    (let [sort-direction @(rf/subscribe [:role-table.db/sort-direction column-key])]
      [t/table-head-sortable
       {:sort-direction sort-direction
        :on-click #(rf/dispatch [:role-table.db/sort-column column-key])
        :data-testid (str "role-table-" (name column-key) "-column")
        :class ["table-role__column"
                (str "table-role__column--" (name column-key))]}
       label])
    [t/table-head
     {:data-testid (str "role-table-" (name column-key) "-column")
      :class ["table-role__column"
              (str "table-role__column--" (name column-key))]}
     label]))

(defn table
  []
  [t/table {:class "table-role"
            :data-testid "role-table"}
   [t/table-row {}
    (for [{:keys [column-key] :as field} fields]
      ^{:key column-key} [column field])]
   (let [{:keys [state value]} @(rf/subscribe [:role-table.db/value])
         search @(rf/subscribe [:role-table.db/search-term])]
     (cond
       (= :failure state) [t/table-message "Could not load Roles"]
       (= :pending state) [t/table-message "Loading Roles"]
       (and (not-empty search)
            (empty? value)) [t/table-message "No Roles found for this term"]
       (empty? value) [t/table-message "No Roles have been created yet"]
       (= :success state)
       (for [role value]
         ^{:key (:id role)} [row role])))])

(defui filter-input
  []
  ($ input
     {:onChange #(do (rf/dispatch [:role-table.db/search-term (-> % .-target .-value)])
                     (rf/dispatch [:role-table.db/confirm-search]))
      :data-testid "search-input"
      :placeholder "Search by name"
      :fullWidth false
      :sx #js {:minWidth "35rem"}}))

(defui pages []
  ($ Pagination
     {:count (use-subscribe [:role-table.db/page-count])
      :page (inc (use-subscribe [:role-table.db/page-cursor]))
      :on-change (fn [_e v] (rf/dispatch [:role-table.db/page (dec v)]))}))
